import _ from 'lodash';
import { INIT_ROOT } from '../actionTypes';

export default function isFleet(state, action) {
  switch (action.type) {
    case INIT_ROOT:
      return _.endsWith(action.payload.params.brand, 'fleet');
    default:
      return state || false;
  }
}
